module.exports = __webpack_public_path__ + "img/banner.b28a476d.png";